import { Link, Text } from '@sbab-ui/components'
import { numberToStringWithSpaces } from '../lib/utils'
import { AppState } from '../state/fixedAppState'

interface Props {
  appState: AppState
}

export default function SlideOverContentCorporateFixed({ appState }: Readonly<Props>) {
  const { placementAmount, interestRateObjs, interestRateIndex } = appState
  const { bindingPeriod, amount, customerRate } = interestRateObjs[interestRateIndex]
  const accumulatedInterest = Math.floor(+amount)
  const resultFromPlacement = accumulatedInterest + placementAmount
  const totalMessage =
    +bindingPeriod < 12 ? `${bindingPeriod} månader` : `${+bindingPeriod / 12} år`
  return (
    <div data-cs-mask>
      <Text size="h2" as="h3" className="text-black" mb="2x">
        Ränteberäkning
      </Text>
      <Text size="paragraph" as="p" className="text-black" mb="1x">
        Insatt belopp: {numberToStringWithSpaces(placementAmount)} kr
      </Text>
      <Text size="paragraph" as="p" className="text-black" mb="1x">
        Avkastning (ränta): {numberToStringWithSpaces(accumulatedInterest)} kr
      </Text>
      <Text size="paragraph" as="p" className="text-black" mb="2x">
        Bindningstid: {totalMessage}
      </Text>
      <Text size="paragraph" as="p" className="text-black" mb="2x">
        Vilket ger ett totalbelopp på {numberToStringWithSpaces(resultFromPlacement)} kr efter{' '}
        {totalMessage}.
      </Text>
      <Text size="paragraph" as="p" className="text-black" mb="1x">
        Resultatet i den här uträkningen ska ses som ett räkneexempel. Räntan och förfallodagen på
        fasträntekontot bestäms den aktuella dagen när fasträntekontot öppnas.
      </Text>
      <Text size="paragraph" as="p" className="text-black" mb="1x">
        Vi har räknat med att räntan på fasträntekontot är dagens aktuella ränta, dvs.{' '}
        <span className="font-semibold">
          {(+customerRate).toFixed(2).toString().replace('.', ',')} %
        </span>{' '}
        för perioden {totalMessage}. Aktuella räntesatser går alltid att se på{' '}
        <Link
          href="/1/privat/vara_rantor/vara_sparrantor"
          className="w-fit !text-link focus:outline-none focus:ring focus:ring-focus_blue"
        >
          sbab.se
        </Link>
        . I uträkningen har vi inte tagit hänsyn till skatter, inflation eller eventuella avgifter
        för att avsluta fasträntekontot i förtid.
      </Text>
      <Text size="paragraph" as="p" className="text-black" mb="1x">
        Ränta räknas för samtliga kalenderdagar under året, alltså 365 dagar. Under skottår räknas
        ränta 366 dagar.
      </Text>
      <Text size="paragraph" as="p" className="text-black" mb="1x">
        Upplupen ränta betalas ut när kontot avslutas. Om räntan är högre än 100 kr per kontohavare
        dras 30 % i skatt.
      </Text>
    </div>
  )
}
